module.exports = __webpack_public_path__ + "static/media/trust.211f6e50.svg";